if (!customElements.get('product-price')) {
	customElements.define('product-price', class ProductPrice extends HTMLElement {
		update(price, compareAtPrice, noConvert = false) {
      const currentPrice = Number(price) || 0;
      const previousPrice = Number(compareAtPrice) || 0;
      const isOnSale = previousPrice > currentPrice;

      this.classList.toggle('price--on-sale', isOnSale);

      const priceText = Shopify.showPrice(currentPrice, noConvert);
      this.querySelectorAll('.price__regular .price-item--regular, .price-item--sale').forEach((priceTag) => {
        this.renderMoney(priceTag, priceText);
      });

      const comparePrice = this.querySelector('[data-compare-price]');
      if (comparePrice) {
        this.renderMoney(comparePrice, Shopify.showPrice(isOnSale ? previousPrice : currentPrice, noConvert));
      }

      this.querySelectorAll('[data-price-savings]').forEach((badge) => {
        badge.hidden = !isOnSale;
        badge.textContent = isOnSale ? this.savingsLabel(badge, currentPrice, previousPrice, noConvert) : '';
      });
    }

    savingsLabel(badge, currentPrice, previousPrice, noConvert) {
      const saved = previousPrice - currentPrice;
      const percentage = Math.round((saved * 100) / previousPrice);
      const percentageThreshold = Number(badge.dataset.savingsPercentageThreshold);
      const moneyThreshold = Number(badge.dataset.savingsMoneyThreshold);

      if (percentage >= percentageThreshold) return `AHORRA ${percentage}%`;
      if (saved >= moneyThreshold) return `AHORRA ${this.savingsMoney(saved, noConvert)}`;
      return `AHORRA ${percentage}%`;
    }

    savingsMoney(value, noConvert) {
      return Shopify.showPrice(value, noConvert).replace(/([.,]00)(?=\D*$)/, '');
    }

    renderMoney(target, formattedPrice) {
      target.replaceChildren();

      if (!formattedPrice.includes('$')) {
        target.textContent = formattedPrice;
        return;
      }

      const wrapper = document.createElement('span');
      wrapper.className = 'price-money';

      const accessible = document.createElement('span');
      accessible.className = 'visually-hidden';
      accessible.textContent = formattedPrice;

      const visual = document.createElement('span');
      visual.className = 'price-money__visual';
      visual.setAttribute('aria-hidden', 'true');

      const symbol = document.createElement('span');
      symbol.className = 'price-money__symbol';
      symbol.textContent = '$';

      const amount = document.createElement('span');
      amount.className = 'price-money__amount';
      amount.textContent = formattedPrice.replace('$', '').trim();

      visual.append(symbol, amount);
      wrapper.append(accessible, visual);
      target.append(wrapper);
    }
	});
}
